module.exports = __webpack_public_path__ + "static/media/40.f2e59db5.jpg";